import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const CategoryFilters = ({
  searchTerm,
  onSearchChange,
  levelFilter,
  onLevelFilterChange,
  onExportExcel,
  onCreateCategory,
  totalCategories = 0,
  filteredCount = 0
}) => {
  const levelOptions = [
    { value: 'all', label: 'All Levels' },
    { value: '1', label: 'Level 1 (Root)' },
    { value: '2', label: 'Level 2' },
    { value: '3', label: 'Level 3' },
    { value: '4', label: 'Level 4' }
  ];

  const clearFilters = () => {
    onSearchChange('');
    onLevelFilterChange('all');
  };

  const hasActiveFilters = searchTerm || levelFilter !== 'all';

  return (
    <div className="bg-card rounded-lg border border-border p-6 space-y-4">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <h2 className="text-xl font-semibold text-foreground">Product Categories</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Manage your product category hierarchy and organization
          </p>
        </div>
        
        <div className="flex items-center space-x-3">
          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            onClick={onExportExcel}
          >
            Export Excel
          </Button>
          <Button
            iconName="Plus"
            iconPosition="left"
            onClick={onCreateCategory}
          >
            Create Category
          </Button>
        </div>
      </div>
      {/* Filters */}
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Search */}
        <div className="flex-1">
          <div className="relative">
            <Input
              type="search"
              placeholder="Search categories by name or parent..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="pl-10"
            />
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
            />
          </div>
        </div>

        {/* Level Filter */}
        <div className="lg:w-48">
          <select
            value={levelFilter}
            onChange={(e) => onLevelFilterChange(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-background text-foreground"
          >
            {levelOptions?.map(option => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Clear Filters */}
        {hasActiveFilters && (
          <Button
            variant="outline"
            iconName="X"
            onClick={clearFilters}
          >
            Clear
          </Button>
        )}
      </div>
      {/* Results Summary */}
      <div className="flex items-center justify-between text-sm text-muted-foreground border-t border-border pt-4">
        <div className="flex items-center space-x-4">
          <span>
            Showing {filteredCount} of {totalCategories} categories
          </span>
          {hasActiveFilters && (
            <div className="flex items-center space-x-2">
              <Icon name="Filter" size={14} />
              <span>Filters active</span>
            </div>
          )}
        </div>

        {/* Category Level Legend */}
        <div className="hidden lg:flex items-center space-x-4">
          <span className="text-xs font-medium">Levels:</span>
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-1">
              <div className="w-3 h-3 bg-primary/20 rounded-full"></div>
              <span className="text-xs">L1</span>
            </div>
            <div className="flex items-center space-x-1">
              <div className="w-3 h-3 bg-accent/20 rounded-full"></div>
              <span className="text-xs">L2</span>
            </div>
            <div className="flex items-center space-x-1">
              <div className="w-3 h-3 bg-warning/20 rounded-full"></div>
              <span className="text-xs">L3+</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryFilters;